if (typeof window !== 'undefined') {
  require('xtend-library/src/extensions/ajax/ajax.js')
  require('xtend-library/src/extensions/scroll/scroll.js')
  require('xtend-library/src/extensions/slider/slider.js')
  require('xtend-library/src/extensions/smooth/smooth.js')
  require('xtend-library/src/extensions/sticky/sticky.js')
}
